<dx-tab-panel
    [showNavButtons]="true"
>
    <dxi-item title="ProcessingStatus">
        <div *dxTemplate="let data of 'processingStatus'">
            <dx-data-grid
                    [dataSource]="processingStatusForBarcodeData"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
            >
                <dxo-paging [pageSize]="5"></dxo-paging>
                <!-- Columns Configuration -->
                <dxi-column dataField="AttemptsCount" caption="Attempts Count"></dxi-column>
                <dxi-column dataField="BarcodeMappingProcessingStatusId" caption="Barcode Mapping Processing Status ID"></dxi-column>
                <dxi-column dataField="ProcessedByUserFullNameSortableOrPrincipalName" caption="Processed By User"></dxi-column>
                <dxi-column dataField="ProcessedByUserId" caption="Processed By User ID"></dxi-column>
                <dxi-column dataField="ProcessedByUserRoleId" caption="Processed By User Role ID"></dxi-column>
                <dxi-column dataField="ProcessedOn" caption="Processed On"></dxi-column>
                <dxi-column dataField="ProcessingError" caption="Processing Error"></dxi-column>
                <dxi-column dataField="ProcessingPriority" caption="Processing Priority"></dxi-column>
                <dxi-column dataField="ProcessingRequestedByUserFullNameSortableOrPrincipalName" caption="Processing Requested By User"></dxi-column>
                <dxi-column dataField="ProcessingRequestedByUserId" caption="Processing Requested By User ID"></dxi-column>
                <dxi-column dataField="ProcessingRequestedByUserRoleId" caption="Processing Requested By User Role ID"></dxi-column>
                <dxi-column dataField="ProcessingRequestedOn" caption="Processing Requested On"></dxi-column>
                <dxi-column dataField="ProcessingStartedByUserFullNameSortableOrPrincipalName" caption="Processing Started By User"></dxi-column>
                <dxi-column dataField="ProcessingStartedByUserId" caption="Processing Started By User ID"></dxi-column>
                <dxi-column dataField="ProcessingStartedByUserRoleId" caption="Processing Started By User Role ID"></dxi-column>
                <dxi-column dataField="ProcessingStartedOn" caption="Processing Started On"></dxi-column>
                <dxi-column dataField="ProcessingToken" caption="Processing Token"></dxi-column>
                <dxi-column dataField="RowId" caption="Row ID"></dxi-column>
            </dx-data-grid>
        </div>
    </dxi-item>
</dx-tab-panel>
